import { render } from "./MaterialButton.vue?vue&type=template&id=7d0f872f&scoped=true"
import script from "./MaterialButton.vue?vue&type=script&lang=js"
export * from "./MaterialButton.vue?vue&type=script&lang=js"

import "./MaterialButton.vue?vue&type=style&index=0&id=7d0f872f&scoped=true&lang=css"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0f872f"]])

export default __exports__